/** A predicate for "may this user open a page with this access" (nav, landing options, links). */
import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useModule } from '../contexts/ModuleContext';
import type { ModuleId } from './types';
import { canOpenPage, type PageAccess } from './pageAccess';

export function useCanOpenPage(): (access: PageAccess) => boolean {
  const { user } = useAuth();
  const { hasModuleAccess } = useModule();
  const isOwner = user?.role === 'Owner';
  const isExternal = user?.isExternal === true;
  // Stable between renders unless the viewer's role, contractor flag or modules change, so a
  // consumer can list it as a memo dependency (the Cmd+K page index does).
  return useCallback(
    (access: PageAccess) =>
      canOpenPage(access, { isOwner, isExternal, hasModule: (id: ModuleId) => hasModuleAccess(id) }),
    [isOwner, isExternal, hasModuleAccess],
  );
}
